import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

import { unassignedSymbol } from '~/utils'

import { type BrandSettingsInputBrand } from '../../utils'

const schema = z.object({
  brands: z.array(
    z.object({
      id: z.string().optional(),
      name: z.string(),
      attachedBrandMap: z.record(
        z.string(),
        z.union([z.number(), z.null(), z.literal(unassignedSymbol)]),
      ),
    }),
  ),
}) satisfies z.ZodSchema<{ brands: BrandSettingsInputBrand[] }>
export type InputValues = z.infer<typeof schema>
export const resolver = zodResolver(schema)
